'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'rotate';
var width = 512;
var height = 512;
var aliases = [128260,"sync-alt"];
var unicode = 'f2f1';
var svgPathData = ['M32 368L32 468.7 132.8 368 32 368zM379.4 144l100.8 0 0-100.7-100.8 100.7z', 'M480.2 43.3l-100.8 100.7 100.8 0 0-100.7zm32 108.7c0 13.3-10.7 24-24 24l-128.1 0c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l53.5-53.5c-88-71-217.2-65.7-298.9 16.1-39.9 39.9-61.6 91.2-65.1 143.5-.6 8.8-8.2 15.5-17 14.9S.1 247.8 .7 238.9c4-59.7 28.8-118.3 74.4-164 94.3-94.3 243.7-99.6 344.3-16.2L471.2 7c6.9-6.9 17.2-8.9 26.2-5.2S512.2 14.3 512.2 24l0 128zM479.6 270.9c.6-8.8 8.2-15.5 17-14.9s15.5 8.2 14.9 17c-4 59.7-28.8 118.3-74.4 164-94.3 94.3-243.7 99.6-344.3 16.2L41 505c-6.9 6.9-17.2 8.9-26.2 5.2S0 497.7 0 488L0 360c0-13.3 10.7-24 24-24l128.1 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-53.5 53.5c88 71 217.2 65.7 298.9-16.1 39.9-39.9 61.6-91.2 65.1-143.4zM32 368L32 468.7 132.8 368 32 368z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRotate = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;